import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class SuppliedUnitsStats extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {

			start_date 	: "",
			end_date 	: "",
			destination:"all",
			destinations:[],
			type:"all",
			types:[],
			listado:[],
			listado_pdf:[],
			totals:[],
			columns:[
				{title:'CENTRO'},
				{title:'COMPONENTE'},
				{title:'A+'},
				{title:'A-'},
				{title:'B+'},
				{title:'B-'},
				{title:'O+'},
				{title:'O-'},
				{title:'AB+'},
				{title:'AB-'},
				{title:'TOTAL'}
			],
			filename:"Estadistica de Unidades Suministradas",
			option:"all",
			format:"",
			destination_name:"",
			type_name:"",
			option_name:"",
			totals:[],
			date_hour:"",
			medical:"",
			status:"NO",
			components:[],
			options_array:["all"],
			total:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		

		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				response.unshift({name:'Todos', key:'all'});

				this.setState({components:response});

				this.$select = $(this.select);
				this.$select.chosen();
				this.$select.on('change', (e)=>{
					this.handleChange(e);
				});
			}
		})

		fetch(Config.default.apiGateway.URL+'national_centers/expenses', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({destinations:response});
			}
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		var cols = [];

		if(this.state.format === 'by_center_component'){
			cols = [ {
		            targets: [ 0 ],
		            visible: this.state.format === 'by_center_component' ? false : true,
		            width: '50%',
		        },
		        {
		        	targets: [ 1 ],
		        	width: '50%',
		        }];
		}else{
			cols = [ {
	            targets: [ 0 ],
	            visible: this.state.format === 'by_center_component' ? false : true,
	            width: '50%',
	        }]
		}

		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						doc.content.splice(3, 0, {
							columns:[
								this.state.destination !== "all" && this.state.destination !== "" ?
									{text: 'Destino', width:'5%', fontSize:6.5}
								: {text:"", width:0},
								this.state.destination !== "all" && this.state.destination !== "" ?
									{text: this.state.destination_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.type !== "all" && this.state.type !== ""  ?
									{text: 'Tipo', width:'5%', fontSize:6.5}
								: {text:"", width:0},
								this.state.type !== "all" && this.state.type !== "" ?
									{text: this.state.type_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.option !== "all" && this.state.option !== ""  ?
									{text: 'Mostrar', width:'5%', fontSize:6.5}
								: {text:"", width:0},
								this.state.option !== "all" && this.state.option !== "" ?
									{text: this.state.option_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});

						var head = []

						this.state.columns.map((c, i)=>{
							if(this.state.format === 'by_center_component'){
								if(i > 0){
									head.push({text:c.title, style:'tableHeader'})
								}
							}else{
								head.push({text:c.title, style:'tableHeader'})
							}

							
						})

						this.state.listado_pdf.unshift(head);

                		doc.content[4].table.body = this.state.listado_pdf;

                		var totals_type = '';

							
						if(this.state.format === 'by_component' || this.state.format === 'by_center_component'){
							this.state.totals.map((t, i)=>(
								totals_type += t.text+':  '+t.num+'\t\t'
							))

							totals_type += 'Total: '+this.state.total;
							doc.content.push(
								{text:totals_type, bold:1, margin:[5,10,0,0]}
							);
						}
							

            			doc.content[4].table.widths=["50%","5%","5%","5%","5%","5%","5%","5%","5%","10%"];
                		doc.styles.tableHeader.fontSize = 8;
                		doc.defaultStyle.fontSize = 8; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
			],
			order: [this.state.format === 'by_center_component' ? [ 0, 'desc' ] : [ 0, 'asc' ]],
            rowGroup: {
	            dataSrc: [ 0 ],
	            startRender: ( rows, group )=>{
	            	var head = rows.data().pluck(0)[0];
	            	var totals = rows.data()[0];
	            	var tds = '';
	            	if(head !== ""  && group !== "" && this.state.format === 'by_center_component'){
	            	
	            		totals.map((t, i)=>{
	            			if(i === 0){
								tds += '<td>'+t+'</td>'
	            			}else if(i>1){
	            				if(t === ""){
	            					tds += '<td style="text-align:right;">'+
	            								'<div style="visibility:hidden">0</div>'+
	            							'</td>'
	            				}else{
	            					tds += '<td style="text-align:right">'+t+'</td>'
	            				}
								
	            			}
	            			
	            		})
	            		return $('<tr/>').append( tds )
            			
            		}else{return $('<tr/>')};
	            },
	        },
	        columnDefs:cols,
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
			ordering:true,
			createdRow: (row, data, dataIndex)=>{
				data.map((d, i)=>{
					if(this.state.format === 'by_center' || this.state.format === 'by_component'){
						if(i > 0){
							$('td:eq('+i+')', row).attr('style', 'text-align: right;');
						}else{
							if(d === 'TOTALES'){
			                	$('td', row).attr('style', 'font-weight: bold;text-align: right;');
			                    $('td:eq('+i+')', row).attr('style', 'text-align: right;');
			            	
			                }else{

								$('td:eq('+i+')', row).attr('style', 'text-align: left;');
			                }
							
						}
					}else{
						if(i > 1){
							$('td:eq('+i+')', row).attr('style', 'text-align: right;');
						}else{
							if(data[1] === ""){
								$(row).attr('style', 'display:none');
							}
						}
					}
					


				});
				

			}	
					
		        
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		$('table thead tr').each(function(i){
			
			$(this).children('th').each(function(j){
				if(j > 0 && i === 0){
					$(this).attr('style', 'text-align:right');
				}
				
			})
			
			
		})
		
	}

	handleChange(e){
		

		if(e.target.name === 'destination'){
			this.setState({
				destination_name: e.target.options[e.target.selectedIndex].text,
				[e.target.name]: e.target.value
			})
		}else if(e.target.name === 'type'){
			this.setState({
				type_name: e.target.options[e.target.selectedIndex].text,
				[e.target.name]: e.target.value
			})
		}else if(e.target.name === 'option'){
			this.setState({
				option_name: e.target.options[e.target.selectedIndex].text,
				[e.target.name]: e.target.value
			})
		}else if(e.target.name === 'options_array'){
			var options = e.target.options;
			var value = [];
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push('all');
			    		break;
			    		
			    	}else{
			    		value.push(options[i].value);
			    	}
			    }
			}

			this.setState({
				[e.target.name]: value
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var options =[];
				if(this.state.options_array.findIndex(obj => obj === 'all') !== -1){
					this.state.components.map((o, i)=>{
						if(i > 0){
							options.push(o.key);
						}
					});
				}else{
					options = this.state.options_array
				}

				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					component_type:this.state.component_type,
					option:this.state.type,
					national_center_id:this.state.destination,
					blood_component_id: this.state.blood_component_id,
					search_by:this.state.option,
					format: this.state.format,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					options_array: options,
					status: this.state.status
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/units_supplied_stats',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: [],
						});

						this.setState({
							columns:[
								{title:'A+'},
								{title:'A-'},
								{title:'B+'},
								{title:'B-'},
								{title:'O+'},
								{title:'O-'},
								{title:'AB+'},
								{title:'AB-'},
								{title:'TOTAL'}
							],
						})

						if(this.state.format === 'by_center'){
							this.state.columns.unshift({title:'CENTRO'})
						}else if(this.state.format === 'by_component'){
							this.state.columns.unshift({title:'COMPONENTE'})
						
						}else{
							this.state.columns.unshift({title:'CENTRO'},{title:'COMPONENTE'})
						}
						
						this.forceUpdate();
						
						var list = [], list_pdf = [];
						response.res.map((r)=>{
							var obj = [], obj_pdf = [];

							if(this.state.format === 'by_component'){
								obj.push(r.component);
								
								obj_pdf.push({text: r.component})
								list_pdf.push(obj_pdf);

								this.state.columns.map((col, i)=>{
									if(i > 0){
										var index = r.totals.findIndex(obj => obj.text === col.title);
										
										if(index !== -1){
											obj.push(r.totals[index].num)
											obj_pdf.push({text: r.totals[index].num, alignment:'center'})
										}else{
											if(col.title === 'TOTAL'){
												obj.push(r.total);
												obj_pdf.push({text: r.total, alignment:'center', bold:1})
											}else{
												obj.push('');
												obj_pdf.push({text: ''})
											}
										}
									}
										
								})

								list.push(obj);
								list_pdf.push(obj_pdf);
							}else if(this.state.format === 'by_center'){
								obj.push(r.center);
								obj_pdf.push({text: r.center})

								this.state.columns.map((col, i)=>{
									if(i > 0){
										var index = r.groups.findIndex(obj => obj.text === col.title);
										if(index !== -1){
											obj.push(r.groups[index].num)
											obj_pdf.push({text: r.groups[index].num, alignment:'center'})
										}else{
											if(col.title === 'TOTAL'){
												obj.push(r.total);
												obj_pdf.push({text: r.total, alignment: 'center', bold:1})
											}else{
												obj.push('0');
												obj_pdf.push({text: ''})
											}
										}
									}
									
										
								})

								list.push(obj);
								list_pdf.push(obj_pdf);
							}else{
								obj = [];
								obj_pdf = [];
								obj_pdf.push({text:r.center,bold:1,fillColor:'#dfdfdf'});
								obj.push(r.center, '');

								this.state.columns.map((col, i)=>{
									if(i>1){
										var index = r.totals.findIndex(obj => obj.text === col.title);
										if(index !== -1){
											obj.push(r.totals[index].num)
											obj_pdf.push({text: r.totals[index].num, alignment:'center',bold:1,fillColor:'#dfdfdf'});
										}else{

											if(col.title === 'TOTAL'){
												obj.push(r.total);
												obj_pdf.push({text: r.total,alignment:'center',bold:1,fillColor:'#dfdfdf'});
											}else{
												obj.push('');
												obj_pdf.push({text: '',bold:1,fillColor:'#dfdfdf'});
											}
										}
									}
								})
								list.push(obj);
								list_pdf.push(obj_pdf);
								
								r.components.map((c)=>{
									obj = [];
									obj_pdf = [];
										
									obj.push(r.center, c.component);
									obj_pdf.push({text: c.component})

									this.state.columns.map((col, i)=>{
										if(i>1){
											var index = c.groups.findIndex(obj => obj.text === col.title);
											if(index !== -1){
												obj.push(c.groups[index].num)
												obj_pdf.push({text: c.groups[index].num, alignment:'center'});
											}else{

												if(col.title === 'TOTAL'){
													obj.push(c.total);
													obj_pdf.push({text: c.total, alignment:'center', bold:1})
												}else{
													obj.push('');
													obj_pdf.push({text: ''})
												}
											}
										}
									})
									list.push(obj);
									list_pdf.push(obj_pdf);
								})

							}
							
						});

						if(response.totals !== null){
							list_pdf.push(['','','','','','','','','',''])
							var obj = [], obj_pdf = [];

						
							if(this.state.format === 'by_center_component'){
								obj.push('', 'TOTALES');
							}else{
								obj.push('TOTALES');
							}

							obj_pdf.push({text:'TOTALES', bold:1, alignment:'right'});

							this.state.columns.map((col, i)=>{
								var inicio = 0;
								if(this.state.format === 'by_center_component'){
									inicio = 1
								}
								if(i > inicio){
									var index = response.totals.findIndex(obj => obj.text === col.title);
									if(index !== -1){
										obj.push(response.totals[index].num)
										obj_pdf.push({text:response.totals[index].num, bold:1, alignment:'center'})
									}else{
										if(col.title === 'TOTAL'){
											obj.push(response.total);
											obj_pdf.push({text:response.total, alignment:'center', bold:1});
										}else{
											obj.push('');
											obj_pdf.push('');
										}
									}
								}
							})
						
							list.push(obj);
							list_pdf.push(obj_pdf);
						}

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							listado_pdf:list_pdf,
							totals:response.type_totals,
							total: response.total
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}
	
	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}


	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Distribución ->
					{this.state.filename}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>					

								<div className="form-group">
									<span className="span-min">Destino</span>
									<select className="form-control" name="destination" id="destination"
										value={this.state.destination} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.destinations.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control" name="type" id="type" 
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="patient">PACIENTE</option>
										<option value="distribution">DISTRIBUCIÓN</option>
										
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Mostrar</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="PUBLIC">PUBLICO</option>
										<option value="PRIVATE">PRIVADO</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Incluir unidades devueltas</span>
									<select className="form-control"  name="status" id="status"
										value={this.state.status} onChange={this.handleChange} required>
										<option value="NO">NO</option>
										<option value="SI">SI</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control"  name="format" id="format"
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="by_component">COMPONENTE</option>
										<option value="by_center">HOSPITAL</option>
										<option value="by_center_component">HOSPITAL Y COMPONENTE</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select className="form-control"  name="options_array" id="options_array"
										value={this.state.options_array} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										{this.state.components.map((l, i)=>{
											return <option key={i} value={l.key}>
												{l.name}
											</option>
										})}
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>

								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>

								<div className="col-xs-12">
									{this.state.destination !== 'all' && this.state.destination !== ""?
										<span> 
											Destino:  
											<b style={{marginLeft:"5px"}}>{this.state.destination_name}</b>
										</span>	
									:null}
									{this.state.type  !== "all" && this.state.type !== ""?
										<span style={{marginLeft:"15px"}}>
											Tipo: 
											<b style={{marginLeft:"5px"}}>
												{this.state.type_name}
											</b>
										</span>
									:null}
									{this.state.option  !== "all" && this.state.option !== ""?
										<span style={{marginLeft:"15px"}}>
											Mostrar: 
											<b style={{marginLeft:"5px"}}>
												{this.state.option_name}
											</b>
										</span>
									:null}
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{this.state.format === 'by_component' || this.state.format === 'by_center_component' ?
									<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>										
										{this.state.totals !== null ?
											this.state.totals.map((t, i)=>(
												<div key={i} style={{width:'10%', display:'inline-block'}}>
													<label>{t.text}</label>
													{':  '+t.num}
												</div>
											))
										:null}
										<div style={{width:'10%', display:'inline-block'}}>
											<label>Total</label>
											{':  '+this.state.total}
										</div>
									</div>
								:null}
									
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (SuppliedUnitsStats);